import type {AppSelectOption} from "../../";

export const getTextResolver = (resolveByField = "label") => {
  return (value: string, option?: AppSelectOption): boolean => {
    return String(option?.[resolveByField])?.toLowerCase().includes(value?.toLowerCase());
  };
};